import React, { Component } from 'react';
import Chart from "react-apexcharts";
import Loader from '../Common/Loader';
import ajaxBank from '../../util/remote/ajaxBank';

class MMCollectionsCategorizedChart extends Component {

    state = {
        testing: false,
        statData: false,
        series: [],
        options: {}
    };

    setSeries = (collections) => {
        this.setState({
          series: [
            {
              name: 'Buzztime Load',
              type: 'line',
              data: collections.buzztime_load
            },
            {
              name: 'Pocket Money Deposits',
              type: 'line',
              data: collections.pm_deposit
            },
            {
              name: 'Card Activations',
              type: 'line',
              data: collections.card_activation
            },
            {
              name: 'Wristband Activations',
              type: 'line',
              data: collections.wristband_activation
            },
            {
              name: 'Card Replacements',
              type: 'line',
              data: collections.card_replace
            },
            {
              name: 'Wristband Replacements',
              type: 'line',
              data: collections.wristband_replace
            }
          ]
        });
    };

    setOptions = (months) => {
        this.setState({
          options: {
            chart: {
              type: 'line', 
            //   stacked: true,
              toolbar: {
                show: false
              }
            },
            plotOptions: {
              bar: {
                columnWidth: '90%' ,
                horizontal: false,

              }
            },
            colors: ['#4F8EF7', '#F76E6C', '#43E794', '#FFD166', '#9B51E0', '#00B8A9'],
            stroke: {
              width: [3, 3, 3, 3, 3, 3], // Set stroke width for each series
              curve: 'smooth' 
            },
            fill: {
              opacity: [1, 1, 1, 1, 1, 1], // Set different opacity for each series
              
            },
            labels: months, // Set the labels as months
            markers: {
              size: 0
            },
            yaxis: {
              title: {
                display: false
              },
              min: 0,
              tickAmount: 7
            },
            legend: {
              display: false,
              position: 'top'
            },
            tooltip: {
              shared: true,
              intersect: false,
              y: {
                formatter: function (y) {
                  if (typeof y !== "undefined") {
                    return "UGX. " + y.toFixed(0); // Fix the concatenation here
                  }
                  return y;
                }
              }
            },
            grid: {
              borderColor: '#f1f1f1'
            }
          }
        });
    };
  

    getMMCollectionsCategorized = async () => {
        const server_response = await ajaxBank.fetchMMCollectionsCategorized();
        if (server_response.status === 'OK') {
          this.setState(
            {
              statData: server_response.details,
            },
            () => {
              const data = this.state.statData;
              const months = [];
              const collections = {
                buzztime_load: [],
                pm_deposit: [],
                card_activation: [],
                wristband_activation: [],
                card_replace: [],
                wristband_replace: []
                
              };
      
              // Loop through the months and collect the totals
              Object.keys(data.months).forEach((index) => {
                months.push(data.months[index]);
                // Initialize the totals for each category for the current month
                const buzztimeLoadTotal = data.totals.buzztime_load[index] ? data.totals.buzztime_load[index].total * 1 : 0;
                const pmDepositTotal = data.totals.pm_deposit[index] ? data.totals.pm_deposit[index].total * 1 : 0;
                const cardActivationTotal = data.totals.card_activation[index] ? data.totals.card_activation[index].total * 1 : 0;
                const wristbandActivationTotal = data.totals.wristband_activation[index] ? data.totals.wristband_activation[index].total * 1 : 0;
                const cardReplaceTotal = data.totals.card_replace[index] ? data.totals.card_replace[index].total * 1 : 0;
                const wristbandReplaceTotal = data.totals.wristband_replace[index] ? data.totals.wristband_replace[index].total * 1 : 0;
      
                // Push the totals into the corresponding category array
                collections.buzztime_load.push(buzztimeLoadTotal);
                collections.pm_deposit.push(pmDepositTotal);
                collections.card_activation.push(cardActivationTotal);
                collections.wristband_activation.push(wristbandActivationTotal);
                collections.card_replace.push(cardReplaceTotal);
                collections.wristband_replace.push(wristbandReplaceTotal);
                
                
              });
      
              // Set options for months
              this.setOptions(months);
      
              // Set series data for the categories
              this.setSeries(collections);
            }
          );
        }
    };

    componentDidMount() {
        this.getMMCollectionsCategorized()
    }

    render() {
        return (<>
                <div className="card-option d-flex">
                <div>
                    <h6 className="card-title mb-1">Mobile Money Collections</h6>
                    <p className="text-muted card-sub-title">Total volume of mobile money transactions according to the different categories each month</p>
                </div>
                <div className="card-option-title ml-auto">
                    <div className="btn-group p-0">
                    
                    <button className="btn btn-light btn-sm" type="button">This Year</button>
                                    
                    </div>
                </div>
                </div>
                <div>

                {this.state.statData && this.state.options && this.state.series && <Chart
                                                                                        options={this.state.options}
                                                                                        series={this.state.series}
                                                                                        height={300}
                                                                                    /> }
                {!this.state.statData && <Loader/>}

                </div></>
            
        );
    }
}

export default MMCollectionsCategorizedChart;